<div class="p-2">
    <div *ngIf="!this.isAdding" class="d-block justify-content-center mt-2">
        <div class="d-flex justify-content-end w-100 mb-2">
            <button *ngIf="this.editEnabled" (click)="onNewClick()" class="btn green-btn">
                {{ "SHORTCUT_LIST_COMPONENT_NEW" | translate }}
            </button>
            <button *ngIf="this.editEnabled" (click)="onCloseClick()" class="btn green-btn ml-2">
                {{ "SHORTCUT_LIST_COMPONENT_CLOSE" | translate }}
            </button>
        </div>
        <tablelist class="w-100" [tableInfo]="tableInfo"> </tablelist>
    </div>
    <div *ngIf="this.isAdding" class="d-block justify-content-center mt-2">
        <div class="d-flex justify-content-end w-100 mb-2">
            <button (click)="onNewClick()" class="promo-delete">
                <img src="assets/img/trash.png" class="delete-img" />
            </button>
        </div>
        <forms #formShortcut [formInfo]="formInfo"> </forms>
        <div class="d-flex justify-content-center w-100 mb-2">
            <button
                (click)="onSaveClick()"
                [disabled]="
                    !this.formComponent ||
                    !this.formComponent.form.value.title ||
                    !this.formComponent.form.value.desc ||
                    !this.photosphereUUID
                "
                class="btn w-75 green-btn"
            >
                {{ "SHORTCUT_LIST_COMPONENT_SAVE" | translate }}
            </button>
        </div>
    </div>
</div>
